import React, { useState } from 'react';
import { useViewport } from '@xyflow/react';
import { useForwardPinchToSweepCanvas } from '../sweep-canvas/hooks/useForwardPinchToSweepCanvas';
import CommentPreviewAndThread from './CommentPreviewAndThread';
import { CommentThreadProps } from './types';

interface CommentsLayerDivProps {
  commentsToShow: CommentThreadProps[];
  commentThreadOpened: string | null;
  funnelMapId: string;
  openCommentThread: (commentThread: CommentThreadProps) => void;
  closeCommentThread: () => void;
  canvasLeft: number;
}

const CommentsLayerDiv: React.FC<CommentsLayerDivProps> = ({
  commentsToShow,
  commentThreadOpened,
  funnelMapId,
  openCommentThread,
  closeCommentThread,
  canvasLeft,
}) => {
  const { zoom, x, y } = useViewport();
  const [commentsLayerRef, setCommentsLayerRef] = useState<HTMLDivElement | null>(null);

  useForwardPinchToSweepCanvas({ element: commentsLayerRef });

  return (
    <div
      id="comments"
      style={{
        width: 0,
        height: 0,
        zIndex: 2,
        position: 'relative',
        transform: `translate(${x}px,${y}px) scale(${zoom})`,
        left: canvasLeft,
      }}
      ref={setCommentsLayerRef}
    >
      {commentsToShow.map((commentThread, idx) => (
        <CommentPreviewAndThread
          key={`comment-${idx}-${commentThread.id ?? ''}`}
          commentThread={commentThread}
          isCommentThreadOpened={commentThreadOpened === commentThread.id}
          funnelMapId={funnelMapId}
          openCommentThread={openCommentThread}
          closeCommentThread={closeCommentThread}
        />
      ))}
    </div>
  );
};

export default CommentsLayerDiv;
